module.exports = __webpack_public_path__ + "static/img/footer_wecode_1.b64e1b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer_wecode_1.jpg
// module id = tvZQ
// module chunks = 29